import { render, staticRenderFns } from "./reportList.vue?vue&type=template&id=4f06b336&scoped=true&"
import script from "./reportList.vue?vue&type=script&lang=js&"
export * from "./reportList.vue?vue&type=script&lang=js&"
import style0 from "./reportList.vue?vue&type=style&index=0&id=4f06b336&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f06b336",
  null
  
)

export default component.exports